const globalModel = require('od-modules/xsell/data/global_model');

function membershipRepository() {
    const module = {};

    module.isPrimeUser = function() {
        const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
        const isPrimeBooking = bookingInfo.prime;
        const hasPrimeDiscount = globalModel.get('hasPrimeDiscount');
        const isPrimeUser = globalModel.get('isPrimeUser');

        return Odigeo.CONFIG.shouldRedirectWhitelabelPrime && (hasPrimeDiscount || isPrimeUser || isPrimeBooking);
    };

    module.isPrimeBooking = function() {
        const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
        const isPrimeBooking = bookingInfo.prime;
        const hasPrimeDiscount = globalModel.get('hasPrimeDiscount');
        const isPrimeUser = globalModel.get('isPrimeUser');

        if (hasPrimeDiscount || isPrimeUser || isPrimeBooking) {
            return true;
        } else if (hasPrimeDiscount === false && isPrimeUser === false && isPrimeBooking === false) {
            return false;
        } else {
            return undefined;
        }
    };

    return module;
}

module.exports = membershipRepository();
